import React, {Component} from 'react';
import './PauseScreen.scss';

class PauseScreen extends Component {
  render() {
    const {nbQuestions, currentQuestion, togglePause} = this.props;

    return (
      <div className='SplashScreen'>
        <h1>Question {currentQuestion} sur {nbQuestions}</h1>
        <button className='btn btn-primary' onClick={togglePause}>Reprendre la série</button>
      </div>
    );
  }
}

export default PauseScreen;
